import React from "react";

// Import des hooks et constantes de Thème
import { useTheme } from "../contexts/ThemeContext";
import { THEMES, THEME_COLORS } from "./Constants";

// Suppression des constantes de couleur locales

// Le composant accepte maintenant onEdit
export default function AccountCard({ account, onSelect, onEdit }) {
  // Récupération du thème
  const { currentTheme } = useTheme();
  const themeColors = THEME_COLORS[currentTheme] || THEME_COLORS[THEMES.BLUE];

  if (!account) return null;

  const formatEuro = (value) =>
    new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR",
    }).format(value);

  const variation = account.soldeActuel - account.soldeDebutAnnee;
  // Utilisation des couleurs de succès/danger du thème
  const variationColor = variation >= 0 ? themeColors.success : themeColors.danger;

  // Empêche la navigation lors du clic sur le bouton d'édition
  const handleEditClick = (e) => {
    e.stopPropagation(); // BLOQUE la propagation à la carte parente (onSelect)
    if (onEdit) {
      onEdit();
    }
  };

  return (
    <div
      style={{ ...styles.card, border: `1px solid ${themeColors.secondary}`, backgroundColor: themeColors.inputBackground }}
      onClick={() => onSelect(account)}
    >

      {/* ✅ BOUTON D'ÉDITION (Crayon) */}
      {onEdit && (
        <button
          onClick={handleEditClick}
          // Couleur de fond du bouton dynamique
          style={{ ...styles.editButton, background: themeColors.primary }}
          title="Modifier ce compte"
        >
          &#x270E; {/* Icône crayon simple */}
        </button>
      )}

      <div style={{ ...styles.content, color: themeColors.text }}>
        <strong style={{ ...styles.accountName, color: themeColors.secondary }}>{account.name}</strong>
        <p style={styles.soldeText}>Solde : <span style={styles.soldeValue}>{formatEuro(account.soldeActuel)}</span></p>
        <p style={{ color: variationColor, fontSize: '0.9em' }}>
          Variation (Année) :{" "}
          {variation >= 0 ? "+" : ""}
          {formatEuro(variation)}
        </p>
      </div>
    </div>
  );
}

const styles = {
  card: {
    padding: 20,
    // Bordure et fond gérés dynamiquement
    borderRadius: 8,
    cursor: "pointer",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    position: 'relative',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    // Les styles :hover sont difficiles à appliquer ici
  },
  content: {
    // Couleur de texte gérée dynamiquement
    marginRight: '30px',
  },
  accountName: {
    fontSize: '1.2em',
    // Couleur gérée dynamiquement
    display: 'block',
    marginBottom: '10px',
  },
  soldeText: {
    fontSize: '1.1em',
    margin: '5px 0',
    fontWeight: 'bold',
  },
  soldeValue: {
    // Couleur gérée par le conteneur content (themeColors.text)
  },
  editButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    // Fond géré dynamiquement
    border: 'none',
    cursor: 'pointer',
    fontSize: '0.8em',
    color: '#fff',
    padding: '6px 8px',
    borderRadius: '50%',
    zIndex: 10,
    lineHeight: '1',
    transition: 'background-color 0.2s',
    outline: 'none',
    // NOTE: Pour gérer le `:hover` de manière dynamique dans React, on devrait
    // ajouter un état `isHovered` et le changer avec `onMouseEnter`/`onMouseLeave`.
    // Pour l'instant, nous nous en tenons à la couleur principale du thème.
  }
};